export const ThemeChanger = (value) => ({
  type: 'THEME_CHANGER', // Changed to uppercase for consistency
  payload: value,
})
